import * as tslib_1 from "tslib";
import { environment } from '../environment';
import * as i0 from "@angular/core";
/* tslint:disable:max-file-line-count */
var ToSqlStringService = /** @class */ (function () {
    function ToSqlStringService() {
        var _this = this;
        this.multiValueOperators = ['BETWEEN', 'NOT BETWEEN', 'IN', 'NOT IN'];
        this.numericDataTypes = ['NUMBER', 'FLOAT'];
        this.layerColumnDataTypes = [];
        this.maxOracleItems = 1000;
        this.operatorOptions = [
            { operator: '=', displayText: 'equal to' },
            { operator: '<>', displayText: 'not equal to' },
            { operator: '>', displayText: 'greater than' },
            { operator: '>=', displayText: 'greater than or equal to' },
            { operator: '<', displayText: 'less than' },
            { operator: '<=', displayText: 'less than or equal to' },
            { operator: 'BETWEEN', displayText: 'between' },
            { operator: 'NOT BETWEEN', displayText: 'not between' },
            { operator: 'LIKE', displayText: 'like' },
            { operator: 'NOT LIKE', displayText: 'not like' },
            { operator: 'IN', displayText: 'in' },
            { operator: 'NOT IN', displayText: 'not in' },
            { operator: 'INCLUDES', displayText: 'includes' },
            { operator: 'NOT INCLUDES', displayText: 'does not include' },
            { operator: 'IS NULL', displayText: 'null' },
            { operator: 'IS NOT NULL', displayText: 'not null' },
            { operator: 'GUID', displayText: 'GUID' }
        ];
        /**
         * Recursive method which returns a SQL filter Condition given a Query Object and all of its descendents.
         * @param query takes filter.rootQuery
         */
        this.getSql = function (query, layerColumns, table, prefix) {
            if (layerColumns === void 0) { layerColumns = null; }
            if (table === void 0) { table = null; }
            if (prefix === void 0) { prefix = ''; }
            var e_1, _a;
            if (layerColumns && layerColumns.length > 0) {
                _this.layerColumnDataTypes = layerColumns.map(function (x) { return _this.getKeyValuePair(x.name, x.databaseDataType); });
            }
            var sql = '';
            if (query) {
                if (query.subqueries && query.subqueries.length > 0) {
                    var subqueries = _this.getValidSubqueries(query.subqueries);
                    var conditions = [];
                    try {
                        for (var subqueries_1 = tslib_1.__values(subqueries), subqueries_1_1 = subqueries_1.next(); !subqueries_1_1.done; subqueries_1_1 = subqueries_1.next()) {
                            var subquery = subqueries_1_1.value;
                            var subquerySql = _this.getSql(subquery, [], null, prefix);
                            if (subquerySql && query.operator === 'AND' && subquery.operator === 'OR'
                                && _this.getValidSubqueries(subquery.subqueries).length > 1) {
                                subquerySql = "(" + subquerySql + ")";
                            }
                            if (subquerySql) {
                                conditions.push(subquerySql);
                            }
                        }
                    }
                    catch (e_1_1) { e_1 = { error: e_1_1 }; }
                    finally {
                        try {
                            if (subqueries_1_1 && !subqueries_1_1.done && (_a = subqueries_1.return)) _a.call(subqueries_1);
                        }
                        finally { if (e_1) throw e_1.error; }
                    }
                    sql += conditions.join(" " + query.operator + " ");
                }
                else {
                    if (_this.queryConditionIsValid(query)) {
                        sql += _this.getConditionSql(query, prefix);
                    }
                }
            }
            var parts = [];
            if (table) {
                var fromClause = "SELECT * FROM " + table.owner.toLowerCase() + "." + table.name.toLowerCase() + " " + prefix;
                parts.push(fromClause);
            }
            if (sql) {
                parts.push(sql);
            }
            sql = parts.join(' WHERE ');
            return sql;
        };
        this.getKeyValuePair = function (alias, dataType) {
            var pair = { key: alias, value: dataType };
            return pair;
        };
        this.getConditionSql = function (query, prefix) {
            if (prefix === void 0) { prefix = ''; }
            var prefixAddition = prefix.length > 0 ? prefix + "." : '';
            if (query.value === undefined || query.value === null) {
                query.value = '';
            }
            var columnName = query.field.toLowerCase();
            if (columnName === 'has_geometry') {
                columnName = "NVL2(" + prefixAddition + "GEOMETRY,'Y','N')";
            }
            if (query.operator !== 'GUID') {
                _this.validateValue(query);
            }
            var includeSingleQuote = !_this.isQueryFieldNumeric(query);
            var includeUpper = _this.includeUpper(query);
            if (query.operator.indexOf('BETWEEN') >= 0) {
                var isDate = _this.getQueryDataType(query) === 'DATE';
                return _this.getBetweenCondition(columnName, query.value.split(','), query.operator, includeSingleQuote, isDate, includeUpper, _this.getQueryDataType(query));
            }
            else if (_this.getQueryDataType(query) === 'DATE') {
                return _this.getDateCondition(columnName, query.operator, query.value, query.multiValue);
            }
            else if (query.operator === 'INCLUDES' || query.operator === 'NOT INCLUDES') {
                return _this.getIncludesFullValue(query, includeUpper);
            }
            else if (_this.multiValueOperators.includes(query.operator)) {
                if (query.isMultiple && query.multiValue) {
                    return _this.getMultivalueCondition(columnName, query.multiValue, includeSingleQuote, query.operator, includeUpper, query.separatorCharacter, _this.getQueryDataType(query));
                }
                else {
                    return _this.getMultivalueCondition(columnName, query.value.split(','), includeSingleQuote, query.operator);
                }
            }
            else if (query.operator === 'GUID') {
                return _this.getMultivalueCondition(columnName, query.value.split(','), includeSingleQuote, query.operator);
            }
            else {
                var value = query.value;
                if (value != null) {
                    if (query.operator.indexOf('LIKE') >= 0) {
                        if (value.indexOf('%') < 0) {
                            value = "%" + query.value + "%";
                        }
                    }
                }
                if (_this.getQueryDataType(query) === 'CLOB') {
                    var operator = void 0;
                    if (query.operator === '=') {
                        operator = 'LIKE';
                    }
                    else if (query.operator === '<>') {
                        operator = 'NOT LIKE';
                    }
                    else {
                        return _this.getCondition(columnName, query.operator, value, includeSingleQuote, includeUpper, false, _this.getQueryDataType(query));
                    }
                    return _this.getCondition(columnName, operator, value, includeSingleQuote, includeUpper);
                }
                else {
                    return _this.getCondition(columnName, query.operator, value, includeSingleQuote, includeUpper);
                }
            }
        };
        this.isQueryFieldNumeric = function (query) {
            var queryDataType = _this.getQueryDataType(query);
            return queryDataType !== null && _this.numericDataTypes.includes(queryDataType);
        };
        this.validateValue = function (query) {
            var valid = !query.value || !_this.isQueryFieldNumeric(query) || _this.areValuesNumeric(query) || query.value.indexOf('{') === 0 || query.value === 'NULL';
            if (!valid) {
                throw new Error(query.field + " is a numeric type but '" + query.value + "' is not numeric.");
            }
        };
        this.getIncludesFullValue = function (query, includeUpper) {
            var not = query.operator === 'NOT INCLUDES';
            var valuesArray;
            if (query.multiValue.length > 0) {
                valuesArray = query.multiValue.map(function (x) { return _this.getIncludesCondition(query.field, x.trim(), not, includeUpper); });
            }
            else {
                valuesArray = query.value.split(',').map(function (x) { return _this.getIncludesCondition(query.field, x.trim(), not); });
            }
            var includesoperator = not ? 'AND' : 'OR';
            return valuesArray.join(" " + includesoperator + " ");
        };
        /**
         * Since Oracle has a limit of 1000 items in the IN clause, we handle that here
         */
        this.getMultivalueCondition = function (fieldName, values, includeSingleQuote, op, includeUpper, separatorCharacter, columnDataType) {
            if (includeSingleQuote === void 0) { includeSingleQuote = false; }
            if (op === void 0) { op = 'IN'; }
            var e_2, _a;
            var items = [];
            var clauses = [];
            var quote = includeSingleQuote ? '\'' : '';
            var isClob = columnDataType === 'CLOB';
            var isNot = op.toUpperCase().indexOf('NOT') >= 0;
            var result = '';
            while (fieldName.indexOf('.') >= 0) {
                fieldName = fieldName.slice(fieldName.indexOf('.') + 1);
            }
            if (includeUpper) {
                fieldName = "UPPER(" + fieldName + ")";
            }
            try {
                for (var values_1 = tslib_1.__values(values), values_1_1 = values_1.next(); !values_1_1.done; values_1_1 = values_1.next()) {
                    var value = values_1_1.value;
                    if (value.toUpperCase() !== 'NULL') {
                        if (isClob) {
                            items.push((isNot ? 'NOT ' : '') + "REGEXP_LIKE(" + fieldName + ", '(^|\\" + separatorCharacter + "|\\" + separatorCharacter + " )" + value + "( \\" + separatorCharacter + "|\\" + separatorCharacter + "|$)')");
                        }
                        else {
                            items.push("" + quote + _this.replaceAnyVariables(value) + quote);
                        }
                    }
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (values_1_1 && !values_1_1.done && (_a = values_1.return)) _a.call(values_1);
                }
                finally { if (e_2) throw e_2.error; }
            }
            var isNull = items.length < values.length;
            if (items.length) {
                if (isClob) {
                    clauses.push(items.join(isNot ? ' AND ' : ' OR '));
                }
                else {
                    while (items.length > 0) {
                        clauses.push(_this.getCondition(fieldName, op, "(" + items.splice(0, _this.maxOracleItems).join(',') + ")", false, false, true));
                    }
                }
                result = "(" + clauses.join(isNot ? ' AND ' : ' OR ') + ")";
            }
            if (isNot && isNull) {
                result += (result.length ? ' AND ' : '') + _this.getCondition(fieldName, 'IS NOT NULL', '');
            }
            else if (isNot || isNull) {
                result += (result.length ? ' OR ' : '') + _this.getCondition(fieldName, 'IS NULL', '');
            }
            return "(" + result + ")";
        };
        /**
         * Returns a condition SQL statement given the field, operator and value
         */
        this.getCondition = function (field, op, value, includeSingleQuote, includeUpper, isMultiple, dataType) {
            if (includeSingleQuote === void 0) { includeSingleQuote = false; }
            if (includeUpper === void 0) { includeUpper = false; }
            if (isMultiple === void 0) { isMultiple = false; }
            if (dataType === void 0) { dataType = ''; }
            if (value === 'NULL') {
                if (op === '<>' || op === 'IS NOT') {
                    op = 'IS NOT NULL';
                }
                else {
                    op = 'IS NULL';
                }
            }
            if (op.indexOf('NULL') >= 0) {
                value = null;
            }
            if (includeUpper) {
                field = "UPPER(" + field + ")";
            }
            if ((op === '>' || op === '>=' || op === '<' || op === '<=') && dataType === 'CLOB') {
                field = "CAST(" + field + " AS VARCHAR2(100))";
            }
            var parts = [field, op];
            if (value) {
                if (includeUpper) {
                    value = value.toUpperCase();
                }
                if (typeof value !== 'number') {
                    value = isMultiple ? (includeSingleQuote ? "'" + value + "'" : value) : _this.formatvalue(value, includeSingleQuote);
                }
                parts.push(value);
            }
            return parts.join(' ');
        };
        /**
         * Returns condition for comparing a date using Oracle's TRUNC and TO_DATE
         */
        this.getDateCondition = function (field, op, value, multiValue) {
            field = field.toUpperCase();
            if (op.indexOf('NULL') < 0) {
                var format = void 0;
                if (_this.hasAnyVariables(value)) {
                    value = _this.replaceAnyVariables(value, true);
                    format = "EXTRACT(year FROM " + field + ") " + op + " " + value;
                }
                else {
                    if (!field.length) {
                        if (value.indexOf('/') > -1) {
                            format = "TO_DATE('" + value + "', 'MM/DD/YYYY')";
                        }
                        else {
                            format = "TO_DATE('" + value + "', 'YYYY-MM-DD')";
                        }
                    }
                    else {
                        value = _this.replaceAnyVariables(value, true);
                        if (value.toUpperCase() === 'NULL') {
                            switch (op) {
                                case '<>':
                                case 'NOT LIKE':
                                case 'NOT IN':
                                case 'NOT INCLUDES':
                                    op = 'IS NOT NULL';
                                    break;
                                default:
                                    op = 'IS NULL';
                                    break;
                            }
                            format = "TRUNC(" + field + ") " + op;
                        }
                        else if (op.toLowerCase().endsWith('in') && multiValue) {
                            var values = multiValue.map(function (v) { return _this.getDateConversionString(v); });
                            format = _this.getMultivalueCondition("TRUNC(" + field + ")", values, false, op);
                        }
                        else {
                            format = "TRUNC(" + field + ") " + op + " TO_DATE('" + value + "', 'YYYY-MM-DD')";
                        }
                    }
                }
                return format;
            }
            return _this.getCondition(field, op, value);
        };
        /**
         * Returns condition for checking if the value is included in a comma separated field value
         */
        this.getIncludesCondition = function (field, value, not, includeUpper) {
            if (not === void 0) { not = false; }
            if (includeUpper === void 0) { includeUpper = false; }
            if (includeUpper) {
                field = "UPPER(" + field + ")";
            }
            var sql = "REGEXP_LIKE(" + field + ", '" + value + "')";
            if (not) {
                sql = "NOT " + sql;
            }
            return sql;
        };
        /**
         * Formats the value in a condition statement
         */
        this.formatvalue = function (value, includeSingleQuote) {
            value = _this.replaceAnyVariables(value);
            if (value.toUpperCase() === 'NULL') {
                return 'NULL';
            }
            return includeSingleQuote ? "'" + value.trim() + "'" : value;
        };
        this.replaceVariables = [
            'currentYear',
            'currentFiscalYear',
            'currentFirstDayOfYear'
        ];
    }
    ToSqlStringService.prototype.getChildWhereClause = function (childTableQuery, childPrefix) {
        var e_3, _a;
        var sql = '';
        if (childTableQuery && childTableQuery.subqueries && childTableQuery.subqueries.length > 0) {
            var subqueries = this.getValidSubqueries(childTableQuery.subqueries);
            var conditions = [];
            try {
                for (var subqueries_2 = tslib_1.__values(subqueries), subqueries_2_1 = subqueries_2.next(); !subqueries_2_1.done; subqueries_2_1 = subqueries_2.next()) {
                    var subquery = subqueries_2_1.value;
                    var subquerySql = this.getSql(subquery, [], null, childPrefix);
                    if (subquerySql && childTableQuery.operator === 'AND' && subquery.operator === 'OR'
                        && this.getValidSubqueries(subquery.subqueries).length > 1) {
                        subquerySql = "(" + subquerySql + ")";
                    }
                    if (subquerySql) {
                        conditions.push(subquerySql);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (subqueries_2_1 && !subqueries_2_1.done && (_a = subqueries_2.return)) _a.call(subqueries_2);
                }
                finally { if (e_3) throw e_3.error; }
            }
            var finalCondition = conditions.join(" " + childTableQuery.operator + " ");
            sql += conditions.length > 1 ? "(" + finalCondition + ")" : finalCondition;
        }
        else {
            if (this.queryConditionIsValid(childTableQuery)) {
                sql += this.getConditionSql(childTableQuery, childPrefix);
            }
        }
        return sql;
    };
    ToSqlStringService.prototype.getChildTableFilter = function (childTableRecord, prefix, childPrefix) {
        if (childTableRecord) {
            var childKeyColumnNames = childTableRecord.childParentKeyColumnName.split('||');
            var parentKeyColumnNames = childTableRecord.parentPrimaryKeyColumnName.split('||');
            var clauses = [];
            for (var i = 0; i < childKeyColumnNames.length; i++) {
                var clause = '';
                if (childKeyColumnNames[i].toUpperCase().includes('DECODE')) {
                    clause = "(TO_CHAR(" + childKeyColumnNames[i] + ") = TO_CHAR(" + parentKeyColumnNames[i] + "))";
                }
                else {
                    clause = "(TO_CHAR(" + (!childKeyColumnNames[i].includes('\'') ? (childPrefix + '.') : '') + childKeyColumnNames[i] + ") = TO_CHAR(" + (!parentKeyColumnNames[i].includes('\'') ? prefix + '.' : '') + parentKeyColumnNames[i] + "))";
                }
                clauses.push(clause);
            }
            return " INNER JOIN " + childTableRecord.childOwner + "." + childTableRecord.childTableName + " " + childPrefix + " ON " + clauses.join(' AND ') + " ";
        }
        return '';
    };
    ToSqlStringService.prototype.getJoinWhereClause = function (joinTableQuery, joinPrefix) {
        var e_4, _a;
        var sql = '';
        if (joinTableQuery && joinTableQuery.subqueries && joinTableQuery.subqueries.length > 0) {
            var subqueries = this.getValidSubqueries(joinTableQuery.subqueries);
            var conditions = [];
            try {
                for (var subqueries_3 = tslib_1.__values(subqueries), subqueries_3_1 = subqueries_3.next(); !subqueries_3_1.done; subqueries_3_1 = subqueries_3.next()) {
                    var subquery = subqueries_3_1.value;
                    var subquerySql = this.getSql(subquery, [], null, joinPrefix);
                    if (subquerySql && joinTableQuery.operator === 'AND' && subquery.operator === 'OR'
                        && this.getValidSubqueries(subquery.subqueries).length > 1) {
                        subquerySql = "(" + subquerySql + ")";
                    }
                    if (subquerySql) {
                        conditions.push(subquerySql);
                    }
                }
            }
            catch (e_4_1) { e_4 = { error: e_4_1 }; }
            finally {
                try {
                    if (subqueries_3_1 && !subqueries_3_1.done && (_a = subqueries_3.return)) _a.call(subqueries_3);
                }
                finally { if (e_4) throw e_4.error; }
            }
            var finalCondition = conditions.join(" " + joinTableQuery.operator + " ");
            sql += conditions.length > 1 ? "(" + finalCondition + ")" : finalCondition;
        }
        else {
            if (this.queryConditionIsValid(joinTableQuery)) {
                sql += this.getConditionSql(joinTableQuery, joinPrefix);
            }
        }
        return sql;
    };
    ToSqlStringService.prototype.getJoinFilter = function (query, prefix, joinPrefix) {
        var sql = '';
        if (query && query.joinRecord && query.joinRecord.isOffsetNumber !== undefined) {
            var baseTableOffsetMark = query.primaryLayerRMSKeys.isOffsetNumber ? '' : "'";
            var joinTableOffsetMark = query.joinRecord && query.joinRecord.isOffsetNumber ? '' : "'";
            var containsPointType = query.primaryLayerRMSKeys.geometryType.toLowerCase().indexOf('points') > -1;
            sql += " INNER JOIN " + query.joinRecord.tableName.split(',')[0] + " " + joinPrefix + " ON (" + joinPrefix + "." + query.joinRecord.ctyCodeColName + " = " + prefix + "." + query.primaryLayerRMSKeys.ctyCodeColName + " AND " + joinPrefix + "." + query.joinRecord.strtnoColName + " = " + prefix + "." + query.primaryLayerRMSKeys.strtnoColName;
            //add JURIS if both base table as well as roadway table has the JURIS columns
            if (query.joinRecord.jurisColName !== '' && query.joinRecord.jurisColName !== null && query.joinRecord.jurisColName !== undefined && query.primaryLayerRMSKeys.jurisColName !== '' && query.primaryLayerRMSKeys.jurisColName !== null && query.primaryLayerRMSKeys.jurisColName !== undefined && query.primaryLayerRMSKeys.jurisColName !== 'NO_JURIS!' && query.joinRecord.jurisColName !== 'NO_JURIS!') {
                sql = sql + " AND NVL(" + joinPrefix + "." + query.joinRecord.jurisColName + ", 'NULL')=NVL(" + prefix + "." + query.primaryLayerRMSKeys.jurisColName + ", 'NULL') ";
            }
            if (query.joinRecord.sideIndColName !== '' && query.joinRecord.sideIndColName !== null && query.joinRecord.sideIndColName !== undefined && query.primaryLayerRMSKeys.sideIndColName !== '' && query.primaryLayerRMSKeys.sideIndColName !== null && query.primaryLayerRMSKeys.sideIndColName !== undefined) {
                sql = sql + " AND " + joinPrefix + "." + query.joinRecord.sideIndColName + "=" + prefix + "." + query.primaryLayerRMSKeys.sideIndColName + " ";
            }
            var rmsJoin = this.getRMSJoin(query, prefix, baseTableOffsetMark, joinPrefix, joinTableOffsetMark, containsPointType);
            sql = sql + rmsJoin + ") ";
        }
        return sql;
    };
    ToSqlStringService.prototype.getRMSJoin = function (query, prefix, baseTableOffsetMark, joinPrefix, joinTableOffsetMark, containsPointType) {
        var a = '', b = '', c = '', d = '', e = '', f = '', g = '', h = '', rmsRow = 0, rmsCol = 0, rmsType = 0, rmsJoin = '';
        if (query.primaryLayerRMSKeys.segBgnColName) {
            a = prefix + "." + query.primaryLayerRMSKeys.segBgnColName;
        }
        if (query.primaryLayerRMSKeys.offsetBgnColName) {
            b = prefix + "." + query.primaryLayerRMSKeys.offsetBgnColName;
        }
        if (query.primaryLayerRMSKeys.segEndColName) {
            c = "NVL(" + prefix + "." + query.primaryLayerRMSKeys.segEndColName + ", " + prefix + "." + query.primaryLayerRMSKeys.segBgnColName + ")";
        }
        if (query.primaryLayerRMSKeys.offsetEndColName) {
            d = "NVL((case " + prefix + "." + query.primaryLayerRMSKeys.offsetEndColName + " WHEN " + baseTableOffsetMark + "0" + baseTableOffsetMark + " THEN " + prefix + "." + query.primaryLayerRMSKeys.offsetBgnColName + " ELSE " + prefix + "." + query.primaryLayerRMSKeys.offsetEndColName + " END)," + prefix + "." + query.primaryLayerRMSKeys.offsetBgnColName + ")";
        }
        if (query.joinRecord.segBgnColName) {
            e = joinPrefix + "." + query.joinRecord.segBgnColName;
        }
        if (query.joinRecord.offsetBgnColName) {
            f = joinPrefix + "." + query.joinRecord.offsetBgnColName;
        }
        if (query.joinRecord.segEndColName) {
            g = "NVL(" + joinPrefix + "." + query.joinRecord.segEndColName + ", " + joinPrefix + "." + query.joinRecord.segBgnColName + ")";
        }
        if (query.joinRecord.offsetEndColName) {
            h = "NVL((CASE " + joinPrefix + "." + query.joinRecord.offsetEndColName + " WHEN " + joinTableOffsetMark + "0" + joinTableOffsetMark + " THEN " + joinPrefix + "." + query.joinRecord.offsetBgnColName + " ELSE " + joinPrefix + "." + query.joinRecord.offsetEndColName + " END)," + joinPrefix + "." + query.joinRecord.offsetBgnColName + ")";
        }
        rmsRow = this.getRMSRow(a, b, c, d, rmsRow);
        rmsCol = this.getRMSCol(e, f, g, h, rmsCol);
        rmsType = rmsRow * rmsCol;
        rmsJoin = this.generateFilterSQL(rmsType, rmsJoin, a, b, c, d, e, f, g, h, containsPointType, query);
        return rmsJoin;
    };
    ToSqlStringService.prototype.generateFilterSQL = function (rmsType, rmsJoin, a, b, c, d, e, f, g, h, containsPointType, query) {
        switch (rmsType) {
            case 16:
            case 32:
            case 48:
            case 17:
            case 18:
                rmsJoin = " AND " + a + " = " + e;
                break;
            case 64:
                rmsJoin = " AND " + e + " BETWEEN " + a + " AND " + c + " ";
                break;
            case 34:
                rmsJoin = " AND " + a + " = " + e + " AND " + f + " = " + b;
                break;
            case 51:
                rmsJoin = " AND " + e + " || LPAD(" + f + ",4,'0') BETWEEN " + a + " || LPAD(" + b + ",4,'0') AND " + a + " || LPAD(" + d + ",4,'0') ";
                break;
            case 68:
                rmsJoin = " AND " + e + " || LPAD(" + f + ",4,'0') BETWEEN " + a + " || LPAD(" + b + ",4,'0') AND " + c + " || LPAD(" + d + ",4,'0') ";
                break;
            case 36:
                rmsJoin = " AND " + a + " || LPAD(" + b + ",4,'0') BETWEEN " + e + " || LPAD(" + f + ",4,'0') AND " + e + " || LPAD(" + h + ",4,'0') ";
                break;
            case 54:
                rmsJoin = " AND " + a + " = " + e + " AND " + b + " = " + f + " AND " + d + " = " + h;
                break;
            case 72:
                rmsJoin = " AND (" + a + " || LPAD(" + b + ",4,'0') BETWEEN " + e + " || LPAD(" + f + ",4,'0') AND " + e + " || LPAD(" + h + ",4,'0') OR " + c + " || LPAD(" + d + ",4,'0') BETWEEN " + e + " || LPAD(" + f + ",4,'0') AND " + e + " || LPAD(" + h + ",4,'0'))";
                if (!containsPointType) {
                    rmsJoin = " AND NOT (" + a + " || LPAD(" + b + ",4,'0') = " + e + " || LPAD(" + h + ",4,'0') OR " + c + " || LPAD(" + d + ",4,'0') = " + e + " || LPAD(" + f + ",4,'0'))";
                }
                break;
            case 19:
                var offsetClause = '';
                if ((query.joinRecord.offsetEndColName !== null && query.primaryLayerRMSKeys.segBgnColName === 'SEG_NO')) {
                    offsetClause = "((" + query.joinRecord.offsetEndColName + " != 0 AND " + a + " <= " + g + ") OR (" + query.joinRecord.offsetEndColName + " = 0 AND " + a + " < " + g + "))";
                }
                else if ((query.primaryLayerRMSKeys.offsetEndColName !== null && query.joinRecord.segBgnColName === 'SEG_NO')) {
                    offsetClause = "((" + query.primaryLayerRMSKeys.offsetEndColName + " != 0 AND " + a + " <= " + g + ") OR (" + query.primaryLayerRMSKeys.offsetEndColName + " = 0 AND " + a + " < " + g + "))";
                }
                if (containsPointType) {
                    rmsJoin = " AND " + a + " BETWEEN " + e + " AND " + g + " ";
                }
                else {
                    if (offsetClause !== '') {
                        rmsJoin = " AND " + a + " >= " + e + " AND " + offsetClause;
                    }
                    else {
                        rmsJoin = " AND " + a + " >= " + e + " AND " + a + " <= " + g;
                    }
                }
                break;
            case 38:
                rmsJoin = " AND " + a + " || LPAD(" + b + ",4,'0') BETWEEN " + e + " || LPAD(" + f + ",4,'0') AND " + g + " || LPAD(" + h + ",4,'0') ";
                break;
            case 57:
                rmsJoin = " AND (" + a + " || LPAD(" + b + ",4,'0') BETWEEN " + e + " || LPAD(" + f + ",4,'0') AND " + g + " || LPAD(" + h + ",4,'0') OR " + a + " || LPAD(" + d + ",4,'0') BETWEEN " + e + " || LPAD(" + f + ",4,'0') AND " + g + " || LPAD(" + h + ",4,'0'))";
                if (!containsPointType) {
                    rmsJoin = " AND NOT (" + a + " || LPAD(" + b + ",4,'0') = " + g + " || LPAD(" + h + ",4,'0') OR " + a + " || LPAD(" + d + ",4,'0') = " + e + " || LPAD(" + f + ",4,'0'))";
                }
                break;
            case 76:
                rmsJoin = " AND ((" + a + " || LPAD(" + b + ",4,'0') BETWEEN " + e + " || LPAD(" + f + ",4,'0') AND " + g + " || LPAD(" + h + ",4,'0') OR " + c + " || LPAD(" + d + ",4,'0') BETWEEN " + e + " || LPAD(" + f + ",4,'0') AND " + g + " || LPAD(" + h + ",4,'0')) OR (" + e + " || LPAD(" + f + ",4,'0') BETWEEN " + a + " || LPAD(" + b + ",4,'0') AND " + c + " || LPAD(" + d + ",4,'0') OR " + g + " || LPAD(" + h + ",4,'0') BETWEEN " + a + " || LPAD(" + b + ",4,'0') AND " + c + " || LPAD(" + d + ",4,'0')))";
                if (!containsPointType) {
                    rmsJoin += " AND NOT (" + a + " || LPAD(" + b + ",4,'0') = " + g + " || LPAD(" + h + ",4,'0') OR " + c + " || LPAD(" + d + ",4,'0') = " + e + " || LPAD(" + f + ",4,'0'))";
                }
                break;
            default:
                break;
        }
        return rmsJoin;
    };
    ToSqlStringService.prototype.getRMSCol = function (e, f, g, h, rmsCol) {
        if (e !== '' && f === '' && g === '' && h === '') {
            rmsCol = 16;
        }
        if (e !== '' && f !== '' && g === '' && h === '') {
            rmsCol = 17;
        }
        if (e !== '' && f !== '' && g === '' && h !== '') {
            rmsCol = 18;
        }
        if (e !== '' && f !== '' && g !== '' && h !== '') {
            rmsCol = 19;
        }
        return rmsCol;
    };
    ToSqlStringService.prototype.getRMSRow = function (a, b, c, d, rmsRow) {
        if (a !== '' && b === '' && c === '' && d === '') {
            rmsRow = 1;
        }
        if (a !== '' && b !== '' && c === '' && d === '') {
            rmsRow = 2;
        }
        if (a !== '' && b !== '' && c === '' && d !== '') {
            rmsRow = 3;
        }
        if (a !== '' && b !== '' && c !== '' && d !== '') {
            rmsRow = 4;
        }
        return rmsRow;
    };
    ToSqlStringService.prototype.getSQLFromQuery = function (rootQuery, baseTable, layerColumns) {
        var e_5, _a;
        var baseTableAlias = 'TBL';
        var joinTableAlias = 'JOINTABLE';
        var childTableAlias = 'CHILDTABLE';
        var baseTableSQL = this.getSql(rootQuery, layerColumns, baseTable, baseTableAlias);
        var sql = baseTableSQL;
        try {
            for (var _b = tslib_1.__values(rootQuery.subqueries), _c = _b.next(); !_c.done; _c = _b.next()) {
                var query = _c.value;
                if (query && (query.joinRecord || query.childTableRecord || query.joinTableQuery || query.childTableQuery)) {
                    var joinTableSQL = this.getJoinFilter(query, query.joinRecord ? baseTableAlias : '', joinTableAlias); //inner join
                    var childTableSQL = this.getChildTableFilter(query.childTableRecord, query.childTableRecord ? baseTableAlias : '', childTableAlias); //inner join
                    var joinWhereClause = this.getJoinWhereClause(query.joinTableQuery, joinTableAlias);
                    var childWhereClause = this.getChildWhereClause(query.childTableQuery, childTableAlias);
                    var baseSQLs = baseTableSQL.toUpperCase().split('WHERE');
                    sql = baseSQLs[0] + joinTableSQL + childTableSQL;
                    var whereClauses = [];
                    if (joinWhereClause !== '') {
                        whereClauses.push(joinWhereClause);
                    }
                    if (childWhereClause !== '') {
                        whereClauses.push(childWhereClause);
                    }
                    if (baseSQLs[1] || joinWhereClause !== '' || childWhereClause !== '') {
                        sql += ' WHERE ';
                        if (baseSQLs.length > 1) {
                            whereClauses.push(baseSQLs[1]);
                        }
                        sql += whereClauses.join(' AND ');
                    }
                }
            }
        }
        catch (e_5_1) { e_5 = { error: e_5_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_5) throw e_5.error; }
        }
        return sql;
    };
    /**
     * Returns the alias given a column name.
     */
    ToSqlStringService.prototype.getAliasFromColumnName = function (columnName, layerColumns) {
        var foundLayerColumn = layerColumns.filter(function (x) { return x.name.toLowerCase() === columnName.toLowerCase(); });
        if (foundLayerColumn.length > 0) {
            return foundLayerColumn[0].alias || columnName;
        }
        return columnName;
    };
    /**
     * Returns the operator option display text for a given an operator.
     */
    ToSqlStringService.prototype.getOperationOptionDisplayTextFromOperator = function (operator) {
        var foundOperaterOption = this.operatorOptions.filter(function (x) { return x.operator.toLowerCase() === operator.toLowerCase(); });
        if (foundOperaterOption.length > 0) {
            return foundOperaterOption[0].displayText;
        }
        return operator;
    };
    /**
     * Returns true if the query itself, field, operator, and value is populated.
     * If the operator is a NULL check the value is then not required.
     */
    ToSqlStringService.prototype.queryConditionIsValid = function (query) {
        if (!query.isMultiple && query.multiValue && query.value && query.value.includes(',') && query.multiValue.join(',') === query.value) {
            return false;
        }
        return !!query && !!query.field && !!query.operator && (query.value !== null || query.operator.indexOf('NULL') >= 0);
    };
    /**
     * Returns the query objects that are valid from a list.
     */
    ToSqlStringService.prototype.getValidSubqueries = function (subqueries) {
        var _this = this;
        return subqueries.filter(function (x) { return !!x && (x.operator === 'AND' || x.operator === 'OR' || _this.queryConditionIsValid(x)); });
    };
    /**
     * Returns the operator options given a data type.
     */
    ToSqlStringService.prototype.getOperatorOptionsForDatatype = function (datatype) {
        if (!datatype) {
            datatype = '';
        }
        switch (datatype.toLowerCase()) {
            case 'number':
            case 'float':
            case 'date':
                return this.operatorOptions.filter(function (x) { return x.operator.indexOf('LIKE') < 0; });
                break;
            default:
                return this.operatorOptions;
                break;
        }
    };
    /**
     * Returns the conditions of the query in a readable form.
     */
    ToSqlStringService.prototype.getSummaryItems = function (query, layerColumns) {
        var e_6, _a;
        var summaryItems = [];
        var validSubqueries = this.getValidSubqueries(query.subqueries);
        try {
            for (var validSubqueries_1 = tslib_1.__values(validSubqueries), validSubqueries_1_1 = validSubqueries_1.next(); !validSubqueries_1_1.done; validSubqueries_1_1 = validSubqueries_1.next()) {
                var subquery = validSubqueries_1_1.value;
                if (subquery.subqueries && subquery.subqueries.length) {
                    summaryItems = summaryItems.concat(this.getSummaryItems(subquery, layerColumns));
                }
                else {
                    var summaryItem = {};
                    summaryItem.field = this.getAliasFromColumnName(subquery.field, layerColumns);
                    summaryItem.operator = this.getOperationOptionDisplayTextFromOperator(subquery.operator);
                    if (summaryItem.operator.indexOf('NULL') < 0) {
                        summaryItem.value = subquery.value;
                    }
                    summaryItems.push(summaryItem);
                }
            }
        }
        catch (e_6_1) { e_6 = { error: e_6_1 }; }
        finally {
            try {
                if (validSubqueries_1_1 && !validSubqueries_1_1.done && (_a = validSubqueries_1.return)) _a.call(validSubqueries_1);
            }
            finally { if (e_6) throw e_6.error; }
        }
        return summaryItems;
    };
    ToSqlStringService.prototype.getSummaryStringForQuery = function (query, layerColumns) {
        var summaryString = '';
        query = this.getSimplifiedDeepCopyOfQuery(query);
        summaryString += this.parseIQueryToString(query, layerColumns);
        if (summaryString.length > 0) {
            summaryString = "when " + summaryString;
        }
        return summaryString;
    };
    ToSqlStringService.prototype.getJoinFilterSummaryFromQuery = function (workingQuery, joinColumns) {
        var summaryItemsString = '';
        var joinItemString = '';
        if (workingQuery.joinRecord) {
            summaryItemsString = "joined to " + workingQuery.joinRecord.layerDisplayName;
        }
        if (workingQuery.joinTableQuery && joinColumns) {
            joinItemString = this.parseIQueryToString(workingQuery.joinTableQuery, joinColumns);
            if (joinItemString !== '') {
                summaryItemsString = summaryItemsString + " where " + joinItemString;
            }
        }
        return summaryItemsString;
    };
    ToSqlStringService.prototype.getChildFilterSummaryFromQuery = function (workingQuery, childColumns) {
        var summaryItemsString = '';
        var childItemString = '';
        if (workingQuery.childTableRecord) {
            if (summaryItemsString !== '') {
                summaryItemsString += ' and ';
            }
            summaryItemsString = "has a child record in " + workingQuery.childTableRecord.layerChildRelationshipName;
        }
        if (workingQuery.childTableQuery && childColumns) {
            childItemString = this.parseIQueryToString(workingQuery.childTableQuery, childColumns);
            if (childItemString !== '') {
                summaryItemsString = summaryItemsString + " where " + childItemString;
            }
        }
        return summaryItemsString;
    };
    ToSqlStringService.prototype.parseIQueryToString = function (query, layerColumns) {
        var e_7, _a;
        var summaryString = '';
        if (query.field) {
            summaryString += this.getSummaryString(query, layerColumns);
        }
        else if (query.subqueries) {
            var validSubqueries = this.getValidSubqueries(query.subqueries);
            try {
                for (var validSubqueries_2 = tslib_1.__values(validSubqueries), validSubqueries_2_1 = validSubqueries_2.next(); !validSubqueries_2_1.done; validSubqueries_2_1 = validSubqueries_2.next()) {
                    var subquery = validSubqueries_2_1.value;
                    if (summaryString.length > 0) {
                        summaryString += query.operator === 'OR' ? ' or ' : ' and ';
                    }
                    summaryString += this.parseIQueryToString(subquery, layerColumns);
                }
            }
            catch (e_7_1) { e_7 = { error: e_7_1 }; }
            finally {
                try {
                    if (validSubqueries_2_1 && !validSubqueries_2_1.done && (_a = validSubqueries_2.return)) _a.call(validSubqueries_2);
                }
                finally { if (e_7) throw e_7.error; }
            }
        }
        return summaryString;
    };
    ToSqlStringService.prototype.getSummaryString = function (query, layerColumns) {
        var summaryItem = {};
        summaryItem.field = this.getAliasFromColumnName(query.field, layerColumns);
        summaryItem.operator = this.getOperationOptionDisplayTextFromOperator(query.operator);
        if (summaryItem.operator.indexOf('NULL') < 0) {
            summaryItem.value = query.value;
        }
        if (summaryItem.operator.toLowerCase() === 'guid') {
            summaryItem.field += "'s";
            summaryItem.operator += ' is ';
        }
        else if (summaryItem.operator.toLowerCase().indexOf('includes') < 0) {
            summaryItem.field += ' is ';
        }
        if (summaryItem.operator.toLowerCase().indexOf('between') >= 0) {
            summaryItem.value = summaryItem.value.replace(',', ' AND ');
        }
        return [summaryItem.field, summaryItem.operator, summaryItem.value].join(' ');
    };
    ToSqlStringService.prototype.getOperatorOptions = function () {
        return this.operatorOptions;
    };
    ToSqlStringService.prototype.cloneSubqueries = function (sourceQuery, destinationQuery) {
        var e_8, _a;
        destinationQuery.subqueries = [];
        try {
            for (var _b = tslib_1.__values(sourceQuery.subqueries), _c = _b.next(); !_c.done; _c = _b.next()) {
                var subquery = _c.value;
                destinationQuery.subqueries.push(this.getSimplifiedDeepCopyOfQuery(subquery));
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_8) throw e_8.error; }
        }
    };
    ToSqlStringService.prototype.getShallowCopyOfQuery = function (query, lowerCase) {
        if (lowerCase === void 0) { lowerCase = true; }
        if (query.field) {
            var newQuery = {
                field: lowerCase ? query.field.toLowerCase() : query.field,
                operator: query.operator,
                value: query.value
            };
            if (query.name) {
                newQuery.name = query.name;
            }
            if (query.isMultiple) {
                newQuery.isMultiple = query.isMultiple;
                newQuery.multiValue = query.multiValue;
            }
            if (query.separatorCharacter) {
                newQuery.separatorCharacter = query.separatorCharacter;
            }
            if (query.dateFormat) {
                newQuery.dateFormat = query.dateFormat;
            }
            return newQuery;
        }
        else {
            return {};
        }
    };
    ToSqlStringService.prototype.getSimplifiedDeepCopyOfQuery = function (query, lowerCase) {
        if (lowerCase === void 0) { lowerCase = true; }
        var e_9, _a;
        var newQuery = {};
        if (!query) {
            return newQuery;
        }
        else if (query.subqueries && query.subqueries.length > 0) {
            newQuery.operator = query.operator;
            var validSubqueries = this.getValidSubqueries(query.subqueries);
            if (validSubqueries.length === 0) {
                return newQuery;
            }
            else if (validSubqueries.length === 1) {
                return this.getSimplifiedDeepCopyOfQuery(validSubqueries[0], lowerCase);
            }
            else {
                newQuery.operator = query.operator;
                newQuery.subqueries = [];
                try {
                    for (var validSubqueries_3 = tslib_1.__values(validSubqueries), validSubqueries_3_1 = validSubqueries_3.next(); !validSubqueries_3_1.done; validSubqueries_3_1 = validSubqueries_3.next()) {
                        var subquery = validSubqueries_3_1.value;
                        var newSubquery = {};
                        if (subquery.isHiddenFilter) {
                            newSubquery = {
                                operator: subquery.operator,
                                isHiddenFilter: subquery.isHiddenFilter,
                                subqueries: subquery.subqueries,
                                dateFormat: subquery.dateFormat
                            };
                        }
                        else {
                            newSubquery = this.getSimplifiedDeepCopyOfQuery(subquery, lowerCase);
                        }
                        newQuery.subqueries.push(newSubquery);
                    }
                }
                catch (e_9_1) { e_9 = { error: e_9_1 }; }
                finally {
                    try {
                        if (validSubqueries_3_1 && !validSubqueries_3_1.done && (_a = validSubqueries_3.return)) _a.call(validSubqueries_3);
                    }
                    finally { if (e_9) throw e_9.error; }
                }
                return newQuery;
            }
        }
        else {
            return this.getShallowCopyOfQuery(query, lowerCase);
        }
    };
    ToSqlStringService.prototype.addFilter = function (layerQuery, newFilter) {
        var query;
        if (layerQuery.field !== undefined) {
            var copiedQuery = this.getSimplifiedDeepCopyOfQuery(layerQuery);
            query = {};
            query.operator = 'AND';
            query.subqueries = [];
            if (copiedQuery) {
                query.subqueries.push(copiedQuery);
            }
            if (newFilter) {
                query.subqueries.push(newFilter);
            }
            delete query.value;
            delete query.field;
        }
        else if (layerQuery.subqueries !== undefined && layerQuery.subqueries.length >= 1) {
            var copiedQuery = this.getSimplifiedDeepCopyOfQuery(layerQuery);
            if (copiedQuery.operator === 'AND') {
                query = copiedQuery;
                if (query.subqueries.length) { // Temp fix for situation where last clause was damaged
                    var lastClause = query.subqueries[query.subqueries.length - 1];
                    if (!this.queryConditionIsValid(lastClause) && !lastClause.subqueries) {
                        query.subqueries.pop();
                    }
                }
                query.subqueries.push(newFilter);
            }
            else {
                query = { operator: 'AND', subqueries: [copiedQuery] };
                query.subqueries.push(newFilter);
            }
        }
        //no filter available set the new filter.
        if ((Object.keys(layerQuery).length === 0 || (!layerQuery.field && !(layerQuery.subqueries && layerQuery.subqueries.length > 0))) && newFilter) {
            query = tslib_1.__assign({}, newFilter);
        }
        // Child Table Query filter setting
        query = this.getChildTableQuery(layerQuery, query);
        // Join Table Query filter setting
        query = this.getJoinTableQuery(layerQuery, query);
        if (Object.keys(layerQuery).length === 0 && !newFilter) {
            query = null;
        }
        if (!query) {
            query = {};
            query.operator = 'AND';
            query.subqueries = [];
        }
        return query;
    };
    ToSqlStringService.prototype.replaceGUID = function (layerQuery, existingGuid, guid) {
        if (layerQuery.subqueries != undefined && layerQuery.subqueries.length > 0) {
            var selectedQuery = layerQuery.subqueries.filter(function (q) { return q.value === existingGuid; })[0];
            selectedQuery.value = guid;
        }
        else if (layerQuery.field !== undefined && layerQuery.value === existingGuid) {
            layerQuery.value = guid;
        }
        return layerQuery;
    };
    ToSqlStringService.prototype.replaceObjQuery = function (layerQuery, existingGuid, guid) {
        if (layerQuery.subqueries != undefined && layerQuery.subqueries.length > 0) {
            var selectedQuery = layerQuery.subqueries.filter(function (q) { return q.value === existingGuid; })[0];
            selectedQuery.value = guid;
        }
        else if (layerQuery.field !== undefined && layerQuery.value === existingGuid) {
            layerQuery.value = guid;
        }
        return layerQuery;
    };
    ToSqlStringService.prototype.getCurrentYear = function () {
        var now = new Date();
        return now.getFullYear();
    };
    ToSqlStringService.prototype.getCurrentFiscalYear = function () {
        var now = new Date();
        var fiscalYearStartingMonth = 6; // 6 = July, month is zero-based
        if (now.getMonth() >= fiscalYearStartingMonth) {
            return now.getFullYear();
        }
        return now.getFullYear() - 1;
    };
    ToSqlStringService.prototype.getFirstDayOfYear = function (delimiter, date) {
        if (delimiter === void 0) { delimiter = ''; }
        if (date === void 0) { date = null; }
        if (!date) {
            date = new Date();
        }
        var year = date.getFullYear().toString();
        return [year, '01', '01'].join(delimiter);
    };
    ToSqlStringService.prototype.addDaysToDate = function (date, days) {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    };
    ToSqlStringService.prototype.addMonthsToDate = function (date, months) {
        var newDate = date.getDate();
        date.setMonth(date.getMonth() + months);
        if (date.getDate() !== newDate) {
            date.setDate(0);
        }
        return date;
    };
    ToSqlStringService.prototype.addYearsToDate = function (date, years) {
        var newYear = date.getFullYear() + years;
        return new Date(newYear, date.getMonth(), date.getDate());
    };
    ToSqlStringService.prototype.getYYYYMMDD = function (delimiter, date) {
        if (delimiter === void 0) { delimiter = ''; }
        if (date === void 0) { date = null; }
        if (!date) {
            date = new Date();
        }
        var zeroPadNum = 2;
        var month = (date.getMonth() + 1).toString().padStart(zeroPadNum, '0');
        var day = date.getDate().toString().padStart(zeroPadNum, '0');
        var year = date.getFullYear().toString();
        return [year, month, day].join(delimiter);
    };
    /*
      * Returns a copy of a query with matching clauses removed.
      */
    ToSqlStringService.prototype.getQueryWithoutClauses = function (query, template) {
        var root = this.getSimplifiedDeepCopyOfQuery(query);
        return this.removeClauses(root, template);
    };
    /*
     * Removes matching clauses from the query and any children subqueries.
     */
    ToSqlStringService.prototype.removeClauses = function (query, template) {
        var _this = this;
        if (query.subqueries) {
            query.subqueries = query.subqueries.filter(function (q) { return _this.removeClauses(q, template).operator; });
        }
        return (query.subqueries && !query.subqueries.length) || this.clauseMatch(query, template) ? {} : query;
    };
    /**
     * Gets matching clauses from the query and any children subqueries.
     * @param query A mapcore query object
     * @param template A string or RegExp if searching by name field or IQueryFind object for more complex field matching queries
     */
    ToSqlStringService.prototype.getClauses = function (query, template) {
        var _this = this;
        template = (typeof template === 'string' || template instanceof RegExp) ? { name: template } : template;
        if (this.clauseMatch(query, template)) {
            return [query];
        }
        else if (query.subqueries) {
            return query.subqueries.flatMap(function (q) { return _this.getClauses(q, template); });
        }
        else {
            return [];
        }
    };
    /*
     * Adds the queryToAdd to the query if it is not already present in the query object
     */
    ToSqlStringService.prototype.addQueryClauseIfNotPresent = function (query, queryToAdd) {
        if (queryToAdd) {
            var clauses = this.getClauses(query, queryToAdd);
            if (!clauses.length && queryToAdd.field) {
                var queryCondition = {
                    field: queryToAdd.field.toString(),
                    operator: queryToAdd.operator.toString(),
                    value: queryToAdd.value !== undefined ? queryToAdd.value.toString() : null
                };
                return this.addFilter(query, queryCondition);
            }
        }
        return query;
    };
    /*
     * Returns a simplified query object with the petl project condition if the layer id is the PETL layer and the query contains a project number condition
     */
    ToSqlStringService.prototype.getPetlProjectIdClauseIfPresent = function (layerId, query, forcePetl) {
        if (environment.layers.find(function (x) { return x.name === 'petl'; }).id === layerId || forcePetl) {
            var projectIdClauses = this.getClauses(query, { field: 'project_no', operator: '=' });
            if (projectIdClauses.length) {
                return this.getSimplifiedQueryClause(projectIdClauses[0]);
            }
        }
        return null;
    };
    /**
     * Return a simplified query object with just the field, operator, and value.
     */
    ToSqlStringService.prototype.getSimplifiedQueryClause = function (query) {
        return { field: query.field, operator: query.operator, value: query.value };
    };
    /*
     * Checks if a query clause matches passed in templates. Returning matching templates or null when no matches are found.
     */
    ToSqlStringService.prototype.clauseMatch = function (clause, template) {
        var _this = this;
        var templates = Array.isArray(template) ? template : [template];
        var matched = templates.filter(function (t) {
            return (!t.field || _this.stringMatch(clause.field, t.field)) &&
                (!t.name || _this.stringMatch(clause.name, t.name)) &&
                (!t.operator || _this.stringMatch(clause.operator, t.operator)) &&
                (!t.value || _this.stringMatch(clause.value, t.value));
        });
        return matched.length ? matched : null;
    };
    /*
     * Returns RegExpMatchArray if string matches or undefined if not.
     */
    ToSqlStringService.prototype.stringMatch = function (stringToMatch, expression) {
        // For the simple string expression, first escape regex special characters. Then allow * and ? to be wildcards
        // by converting their escaped values to the equivalent regex expressions '.*' and '.' respectively.
        var regex = (typeof expression === 'string') ? new RegExp("^" + this.escapeRegExp(expression).replace(/\\\*/gi, '.*').replace(/\\\?/gi, '.') + "$", 'i') : expression;
        return stringToMatch && stringToMatch.match(regex);
    };
    ToSqlStringService.prototype.escapeRegExp = function (stringToescapeRegExp) {
        return stringToescapeRegExp.replace(/[.*+?^${}()|[\]\\]/gi, '\\$&');
    };
    ToSqlStringService.prototype.getQueryDataType = function (query) {
        if (query.field) {
            var dataKeyIndex = this.layerColumnDataTypes ? this.layerColumnDataTypes.findIndex(function (x) { return x.key.toLowerCase() === query.field.toLowerCase(); }) : -1;
            if (dataKeyIndex >= 0) {
                return this.layerColumnDataTypes[dataKeyIndex].value;
            }
        }
        return null;
    };
    ToSqlStringService.prototype.getDateConversionString = function (value) {
        var result;
        var rg1 = /^[0-9]{4}-(((0[13578]|(10|12))-(0[1-9]|[1-2][0-9]|3[0-1]))|(02-(0[1-9]|[1-2][0-9]))|((0[469]|11)-(0[1-9]|[1-2][0-9]|30)))$/g;
        var rg2 = /^[0,1]?\d{1}\/(([0-2]?\d{1})|([3][0,1]{1}))\/(([1]{1}[9]{1}[9]{1}\d{1})|([2-9]{1}\d{3}))$/g;
        if (value.match(rg1)) {
            result = "TO_DATE('" + value.match(rg1)[0] + "', 'YYYY-MM-DD')";
        }
        else if (value.match(rg2)) {
            result = "TO_DATE('" + value.match(rg2)[0] + "', 'MM/DD/YYYY')";
        }
        else if (value.toUpperCase() === 'NULL') {
            result = 'NULL';
        }
        else {
            result = "'" + value + "'";
        }
        return result;
    };
    /**
     * Returns BETWEEN condition
     */
    ToSqlStringService.prototype.getBetweenCondition = function (columnName, values, operator, includeSingleQuote, isDate, includeUpper, dataType) {
        if (includeSingleQuote === void 0) { includeSingleQuote = false; }
        if (isDate === void 0) { isDate = false; }
        if (includeUpper === void 0) { includeUpper = false; }
        var pair = 2;
        if (values.length < pair) {
            values.push('');
        }
        if (includeUpper) {
            columnName = "UPPER(" + columnName + ")";
        }
        if (dataType === 'CLOB') {
            columnName = "CAST(" + columnName + " AS VARCHAR2(100))";
        }
        if (isDate) {
            includeSingleQuote = false;
            return ["TRUNC(" + columnName + ")", operator, this.formatvalue(this.getDateCondition('', operator, values[0]), includeSingleQuote), 'AND', this.formatvalue(values[1] !== '' ? this.getDateCondition('', operator, values[1]) : '', includeSingleQuote)].join(' ');
        }
        return [columnName, operator, this.formatvalue(values[0], includeSingleQuote), 'AND', this.formatvalue(values[1], includeSingleQuote)].join(' ');
    };
    ToSqlStringService.prototype.hasAnyVariables = function (value) {
        var e_10, _a;
        var retVal = false;
        if (value) {
            try {
                for (var _b = tslib_1.__values(this.replaceVariables), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var variable = _c.value;
                    if (value.includes("{" + variable)) {
                        retVal = true;
                        break;
                    }
                }
            }
            catch (e_10_1) { e_10 = { error: e_10_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_10) throw e_10.error; }
            }
        }
        return retVal;
    };
    /**
     * Searches for variables and returns a string with the variable replacements completed
     */
    ToSqlStringService.prototype.replaceAnyVariables = function (value, includeDateDashes) {
        if (includeDateDashes === void 0) { includeDateDashes = false; }
        if (value && value.indexOf('{current') >= 0 && value.indexOf('}') > 0) {
            value = value.replace('{', '').replace('}', '');
            value = value.replace(/currentYear/ig, this.getCurrentYear().toString());
            value = value.replace(/currentFiscalYear/ig, this.getCurrentFiscalYear().toString());
            value = value.replace(/currentFirstDayOfYear/ig, this.getFirstDayOfYear().toString());
            if (value.indexOf('+') || value.indexOf('-')) {
                var components = value.split(/\+|\-| /);
                components = components.filter(function (x) { return x !== ''; });
                if (components.length > 1) {
                    if ((value.indexOf('currentYYYYMMDD') >= 0 || value.indexOf('currentYYYY-MM-DD') >= 0)) {
                        value = this.replaceCurrentDateComparisonValue(value, includeDateDashes);
                    }
                    else {
                        var leftIndex = 0;
                        var rightIndex = components.length - 1;
                        var value1 = void 0;
                        var value2 = void 0;
                        value1 = parseInt(components[leftIndex], 10);
                        value2 = parseInt(components[rightIndex], 10);
                        if (value.includes('-')) {
                            value2 = value2 * -1;
                        }
                        value = (value1 + value2).toString();
                    }
                }
            }
            value = value.replace(/currentYYYYMMDD/ig, this.getYYYYMMDD());
            value = value.replace(/currentYYYY-MM-DD/ig, this.getYYYYMMDD('-'));
            if (includeDateDashes) {
                value = value.replace(/currentDate/ig, this.getYYYYMMDD('-'));
            }
            else {
                value = value.replace(/currentDate/ig, this.getYYYYMMDD());
            }
        }
        return value;
    };
    ToSqlStringService.prototype.replaceCurrentDateComparisonValue = function (value, includeDateDashes) {
        if (includeDateDashes === void 0) { includeDateDashes = false; }
        var components = value.split(/\+|\-| /);
        components = components.filter(function (x) { return x !== ''; });
        if ((value.indexOf('currentYYYYMMDD') >= 0 || value.indexOf('currentYYYY-MM-DD') >= 0)) {
            var rightComponent = components[(components.length - 1)];
            var digitsInString = rightComponent.split('').filter(function (x) { return !isNaN(parseFloat(x)); }).join();
            value = value.replace('currentYYYY-MM-DD', 'currentYYYYMMDD');
            if ((components.length > 1) && digitsInString.length > 0) {
                var newDate = new Date();
                var value2 = parseInt(rightComponent, 10);
                if (value.indexOf('-') >= 0) {
                    value2 = (value2 * -1);
                }
                if ((rightComponent.indexOf('m') >= 0 || rightComponent.indexOf('months') >= 0)) {
                    newDate = this.addMonthsToDate(newDate, value2);
                }
                else if ((rightComponent.indexOf('d') >= 0 || rightComponent.indexOf('days') >= 0)) {
                    newDate = this.addDaysToDate(newDate, value2);
                }
                else {
                    newDate = this.addYearsToDate(newDate, value2);
                }
                if (includeDateDashes) {
                    value = this.getYYYYMMDD('-', newDate);
                }
                else {
                    value = this.getYYYYMMDD('', newDate);
                }
            }
            else if (includeDateDashes) {
                value = value.replace(/currentYYYYMMDD/ig, this.getYYYYMMDD('-'));
            }
            else {
                value = value.replace(/currentYYYYMMDD/ig, this.getYYYYMMDD());
            }
        }
        return value;
    };
    ToSqlStringService.prototype.includeUpper = function (query) {
        var upperOperators = ['=', '<>', 'NOT LIKE', 'LIKE', 'NOT IN', 'IN', 'INCLUDES', 'NOT INCLUDES', '>', '>=', '<', '<=', 'BETWEEN', 'NOT BETWEEN'];
        var queryDataType = this.getQueryDataType(query);
        if (query.value && upperOperators.indexOf(query.operator) >= 0
            && !this.areValuesNumeric(query)
            && this.doValuesContainAlphaChars(query)
            && (query.value.toUpperCase() !== 'NULL')) {
            if (!this.layerColumnDataTypes
                || !queryDataType
                || queryDataType === 'VARCHAR2'
                || queryDataType === 'BLOB'
                || queryDataType === 'CLOB') {
                return true;
            }
            return false;
        }
        return false;
    };
    ToSqlStringService.prototype.areValuesNumeric = function (query) {
        var _this = this;
        var values = (query.multiValue && query.multiValue.length) ? query.multiValue : query.value.split(',');
        return !values.some(function (x) { return x !== 'NULL' && !_this.isNumeric(x); });
    };
    ToSqlStringService.prototype.doValuesContainAlphaChars = function (query) {
        var _this = this;
        var values = query.value.split('').map(function (x) { return x.trim(); });
        return values.filter(function (x) { return _this.isLetter(x); }).length > 0;
    };
    ToSqlStringService.prototype.isNumeric = function (x) {
        return !isNaN(Number(x));
    };
    ToSqlStringService.prototype.isLetter = function (str) {
        var regex = RegExp('^[a-zA-Z()]+$');
        return regex.test(str);
    };
    ToSqlStringService.prototype.buildExternalWorkingSql = function (workingQuery, layerColumns) {
        var _this = this;
        var e_11, _a;
        if (layerColumns && layerColumns.length > 0) {
            this.layerColumnDataTypes = layerColumns.map(function (x) { return _this.getKeyValuePair(x.name, x.databaseDataType); });
        }
        var joinOperator = workingQuery.operator;
        var subqueries = workingQuery.subqueries;
        //iterate through each subquery
        //build each subquery into string format (using getCondition()?)
        //after join() all subqueries with operator
        var sqlBuilder = [];
        try {
            for (var subqueries_4 = tslib_1.__values(subqueries), subqueries_4_1 = subqueries_4.next(); !subqueries_4_1.done; subqueries_4_1 = subqueries_4.next()) {
                var query = subqueries_4_1.value;
                var property = query.field !== null ? query.field : '';
                var operator = query.operator;
                var value = query.value !== null ? (this.isQueryFieldNumeric(query) ? query.value : "'" + query.value + "'") : '';
                sqlBuilder.push([property, operator, value].join(' '));
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (subqueries_4_1 && !subqueries_4_1.done && (_a = subqueries_4.return)) _a.call(subqueries_4);
            }
            finally { if (e_11) throw e_11.error; }
        }
        var retVal = '';
        if (sqlBuilder.length > 1) {
            for (var i = 0; i < sqlBuilder.length; i++) {
                if (i === sqlBuilder.length - 1) {
                    if (sqlBuilder[i] !== ' = ') {
                        retVal += sqlBuilder[i];
                    }
                    else {
                        //dont add ' = ' and remove last joinOperator
                        retVal = retVal.substring(0, retVal.lastIndexOf(joinOperator));
                    }
                }
                else {
                    if (sqlBuilder[i] !== ' = ') {
                        retVal += sqlBuilder[i] + " " + joinOperator + " ";
                    }
                }
            }
        }
        else {
            //if property and value are both blank, set to ''
            retVal = sqlBuilder[0] !== ' = ' ? sqlBuilder[0] : '';
        }
        return retVal.trim();
    };
    ToSqlStringService.prototype.getChildTableQuery = function (layerQuery, query) {
        if (layerQuery.childTableQuery && layerQuery.childTableRecord) {
            if (query === undefined) {
                query = {};
                query.operator = 'AND';
                query.subqueries = [];
            }
            query.childTableRecord = layerQuery.childTableRecord;
            var childTableQuery = this.getSimplifiedDeepCopyOfQuery(layerQuery.childTableQuery, false);
            query.childTableQuery = { subqueries: [{ field: '', operator: '=', value: null }] };
            if (childTableQuery.operator !== 'AND' && childTableQuery.operator !== 'OR') {
                if (childTableQuery.field && childTableQuery.field !== '') {
                    query.childTableQuery.subqueries = [childTableQuery];
                }
                query.childTableQuery.operator = 'AND';
            }
            else {
                query.childTableQuery.operator = childTableQuery.operator;
                query.childTableQuery.subqueries = [].concat(childTableQuery.subqueries);
            }
        }
        return query;
    };
    ToSqlStringService.prototype.getJoinTableQuery = function (layerQuery, query) {
        if (layerQuery.joinTableQuery && layerQuery.joinRecord) {
            if (query === undefined) {
                query = {};
                query.operator = 'AND';
                query.subqueries = [];
            }
            query.joinRecord = layerQuery.joinRecord;
            if (layerQuery.primaryLayerRMSKeys) {
                query.primaryLayerRMSKeys = layerQuery.primaryLayerRMSKeys;
            }
            var joinTableQuery = this.getSimplifiedDeepCopyOfQuery(layerQuery.joinTableQuery, false);
            query.joinTableQuery = { subqueries: [{ field: '', operator: '=', value: null }] };
            if (joinTableQuery.operator !== 'OR' && joinTableQuery.operator !== 'AND') {
                if (joinTableQuery.field && joinTableQuery.field !== '') {
                    query.joinTableQuery.subqueries = [joinTableQuery];
                }
                query.joinTableQuery.operator = 'AND';
            }
            else {
                query.joinTableQuery.operator = joinTableQuery.operator;
                query.joinTableQuery.subqueries = [].concat(joinTableQuery.subqueries);
            }
        }
        return query;
    };
    ToSqlStringService.ngInjectableDef = i0.defineInjectable({ factory: function ToSqlStringService_Factory() { return new ToSqlStringService(); }, token: ToSqlStringService, providedIn: "root" });
    return ToSqlStringService;
}());
export { ToSqlStringService };
